"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI2Logo = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AI2Mark_1 = require("./AI2Mark");
var AI2MarkText_1 = require("./AI2MarkText");
var theme_1 = require("../../theme");
var dimsBySize = {
    micro: {
        height: 16,
        width: {
            mark: 30,
            gap: 9,
            text: 138,
        },
    },
    default: {
        height: 30,
        width: {
            mark: 64,
            text: 189,
            gap: 12,
        },
    },
    lg: {
        height: 37,
        width: {
            mark: 79,
            gap: 14,
            text: 233,
        },
    },
};
/**
 * Component that renders the AI2 Logo.
 */
var AI2Logo = function (p) {
    var props = Object.assign({ size: 'default', color: 'default', includeText: true }, p);
    var dims = dimsBySize[props.size];
    var _a = props.color === 'white' ? [false, theme_1.Theme.color.N1] : [undefined, undefined], gradients = _a[0], color = _a[1];
    if (!props.includeText) {
        return (React.createElement(AI2Mark_1.AI2Mark, { className: props.className, width: dims.width.mark, height: dims.height, gradients: gradients, color: color }));
    }
    // When the logo is small we resize the viewbox of the text so it's more legible.
    var vw = props.size === 'micro' ? '74 6 190 18' : undefined;
    return (React.createElement(LogoGrid, { gap: dims.width.gap, className: props.className },
        React.createElement(AI2Mark_1.AI2Mark, { width: dims.width.mark, height: dims.height, gradients: gradients, color: color }),
        React.createElement(AI2MarkText_1.AI2MarkText, { width: dims.width.text, height: dims.height, color: color, viewBox: vw })));
};
exports.AI2Logo = AI2Logo;
var LogoGrid = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-grid;\n    grid-template-columns: repeat(2, min-content);\n    gap: ", "px;\n"], ["\n    display: inline-grid;\n    grid-template-columns: repeat(2, min-content);\n    gap: ", "px;\n"])), function (_a) {
    var gap = _a.gap;
    return gap;
});
var templateObject_1;
//# sourceMappingURL=AI2Logo.js.map